import get from 'lodash/get';
import {
  CLEAR_STATE,
  LOAD_BOOKING,
  LOAD_BOOKING_SUCCESS,
  LOAD_BOOKING_ERROR,
  UPDATE_BOOKING,
  BOOKING_CHANGED,
  PATCH_BOOKING,
  CANCEL_BOOKING,
  CHARGE_PAYMENT,
  CHARGE_PAYMENT_SUCCESS,
  CHARGE_PAYMENT_ERROR,
  CHARGE_INSTALMENT,
  CHARGE_INSTALMENT_SUCCESS,
  CHARGE_INSTALMENT_ERROR,
  ADD_NOTE,
  ADD_NOTE_SUCCESS,
  EDIT_CUSTOMER_DETAILS_SUCCESS,
  AUTH_USER_SUCCESS,
  PATCH_BOOKING_SUCCESS,
  EDIT_GARAGE_BILL_STATUS_REQUEST,
  EDIT_GARAGE_BILL_STATUS_SUCCESS,
  EDIT_GARAGE_BILL_STATUS_FAILURE,
  GARAGE_BILL_PDF_URL_REQUEST,
  GARAGE_BILL_PDF_URL_SUCCESS,
  GARAGE_BILL_PDF_URL_FAILURE,
  RELOAD_BOOKING,
} from './constants';

export function patchBookingSuccess() {
  return {
    type: PATCH_BOOKING_SUCCESS,
  };
}

export function authUserSuccess(user) {
  return {
    type: AUTH_USER_SUCCESS,
    user,
  };
}

export function patchBookingAction(patch, idempotencyKey) {
  return {
    type: PATCH_BOOKING,
    patch,
    idempotencyKey,
  };
}

export function cancelBookingAction(patch, note, idempotencyKey) {
  return {
    type: CANCEL_BOOKING,
    patch,
    note,
    idempotencyKey,
  };
}

export function chargePaymentAction(idempotencyKey) {
  return {
    type: CHARGE_PAYMENT,
    idempotencyKey,
  };
}

export function chargeInstalmentAction(idempotencyKey) {
  return {
    type: CHARGE_INSTALMENT,
    idempotencyKey,
  };
}

export function addNoteAction(note) {
  return {
    type: ADD_NOTE,
    note,
  };
}

export function addNoteSuccess(payload) {
  return {
    type: ADD_NOTE_SUCCESS,
    payload,
  };
}

export function chargePaymentSuccess(payload) {
  return {
    type: CHARGE_PAYMENT_SUCCESS,
    payload,
  };
}

export function chargePaymentError(error) {
  return {
    type: CHARGE_PAYMENT_ERROR,
    error: error.message,
  };
}

export function chargeInstalmentSuccess(payload) {
  return {
    type: CHARGE_INSTALMENT_SUCCESS,
    payload,
  };
}

export function chargeInstalmentError(error) {
  return {
    type: CHARGE_INSTALMENT_ERROR,
    error: error.message,
  };
}

export function clearState() {
  return {
    type: CLEAR_STATE,
  };
}

export function loadBooking() {
  return {
    type: LOAD_BOOKING,
  };
}

export function bookingLoaded(booking) {
  return {
    type: LOAD_BOOKING_SUCCESS,
    booking,
  };
}

export function updateBookingAction(booking) {
  return {
    type: UPDATE_BOOKING,
    booking,
  };
}

export function bookingError(error) {
  return {
    type: LOAD_BOOKING_ERROR,
    error: get(error, 'response.data.message', error.message),
  };
}

export function bookingChanged(isBookingChanged) {
  return {
    type: BOOKING_CHANGED,
    isBookingChanged,
  };
}

export function reloadBooking() {
  return {
    type: RELOAD_BOOKING,
  };
}

export function editCustomerDetailsSuccess(customer) {
  return {
    type: EDIT_CUSTOMER_DETAILS_SUCCESS,
    customer,
  };
}

export function updateGarageBillStatus(invoiceData) {
  return {
    type: EDIT_GARAGE_BILL_STATUS_REQUEST,
    invoiceData,
  };
}

export function updateGarageBillStatusSuccess(invoiceData) {
  return {
    type: EDIT_GARAGE_BILL_STATUS_SUCCESS,
    invoiceData,
  };
}

export function updateGarageBillStatusFailure(err, message) {
  return {
    type: EDIT_GARAGE_BILL_STATUS_FAILURE,
    err: err || message,
  };
}

export const getGarageBillPdfUrlRequest = (garageId, bookingId) => ({
  type: GARAGE_BILL_PDF_URL_REQUEST,
  data: { garageId, bookingId },
});

export const getGarageBillPdfUrlSuccess = (data) => ({
  type: GARAGE_BILL_PDF_URL_SUCCESS,
  data,
});

export const getGarageBillPdfUrlFailure = (error) => ({
  type: GARAGE_BILL_PDF_URL_FAILURE,
  error,
});
